// Pressure units data for conversion routes
// Base unit: pascal (Pa)

export const pressureUnits = [
  { id: 'pascal', name: 'Pascal', symbol: 'Pa', plural: 'Pascals', factor: 1 },
  { id: 'kilopascal', name: 'Kilopascal', symbol: 'kPa', plural: 'Kilopascals', factor: 1000 },
  { id: 'megapascal', name: 'Megapascal', symbol: 'MPa', plural: 'Megapascals', factor: 1000000 },
  { id: 'bar', name: 'Bar', symbol: 'bar', plural: 'Bars', factor: 100000 },
  { id: 'millibar', name: 'Millibar', symbol: 'mbar', plural: 'Millibars', factor: 100 },
  { id: 'psi', name: 'Pound per square inch', symbol: 'psi', plural: 'Pounds per square inch', factor: 6894.757 },
  { id: 'atmosphere', name: 'Atmosphere', symbol: 'atm', plural: 'Atmospheres', factor: 101325 },
  { id: 'torr', name: 'Torr', symbol: 'Torr', plural: 'Torr', factor: 133.3224 },
  { id: 'mmhg', name: 'Millimeter of mercury', symbol: 'mmHg', plural: 'Millimeters of mercury', factor: 133.3224 },
  { id: 'inhg', name: 'Inch of mercury', symbol: 'inHg', plural: 'Inches of mercury', factor: 3386.389 },
  { id: 'kgf-per-cm2', name: 'Kilogram-force per cm²', symbol: 'kgf/cm²', plural: 'Kilogram-force per cm²', factor: 98066.5 },
];

// Popular conversions matching common usage
export const popularPressureConversions = [
  { from: 'psi', to: 'bar' },
  { from: 'bar', to: 'psi' },
  { from: 'psi', to: 'kilopascal' },
  { from: 'kilopascal', to: 'psi' },
  { from: 'bar', to: 'pascal' },
  { from: 'pascal', to: 'bar' },
  { from: 'atmosphere', to: 'bar' },
  { from: 'bar', to: 'atmosphere' },
  { from: 'atmosphere', to: 'psi' },
  { from: 'psi', to: 'atmosphere' },
  { from: 'mmhg', to: 'pascal' },
  { from: 'pascal', to: 'mmhg' },
  { from: 'torr', to: 'pascal' },
  { from: 'pascal', to: 'torr' },
  { from: 'bar', to: 'kilopascal' },
  { from: 'kilopascal', to: 'bar' },
  { from: 'atmosphere', to: 'pascal' },
  { from: 'pascal', to: 'atmosphere' },
  { from: 'mmhg', to: 'torr' },
  { from: 'torr', to: 'mmhg' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return pressureUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertPressure = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to pascals first, then to target unit
  const pascals = value * fromUnit.factor;
  return pascals / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertPressure(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online pressure unit converter.`;
};
